<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <div class="nav-link cursor-pointer" @click.prevent="useDropDown2()">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fab fa-vuejs text-info text-sm opacity-10"></i>
          </div>
          Product Management
          <i v-if="!dropDownStatus2" class="ms-3 fas fa-angle-right"></i>
          <i v-else class="ms-3 fas fa-angle-down"></i>
        </div>
        <ul v-if="dropDownStatus2">
          <sidenav-item
            url="/products/one-time"
            :class="getRoute() === 'one-time' ? 'active' : ''"
            navText="One Time"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          <sidenav-item
            url="/products/subs"
            :class="getRoute() === 'subs' ? 'active' : ''"
            navText="Subscription"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>        
        </ul>
      </li>


      <li class="nav-item">
        <sidenav-item
          url="/invoices"
          :class="getRoute() === 'invoices' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '-' : 'Invoices'"
        >
          <template v-slot:icon>
            <i class="fa fa-receipt text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> 
      <li class="nav-item">
        <sidenav-item
          url="/subscriptions"
          :class="getRoute() === 'subscriptions' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '-' : 'Subscriptions'"
        >
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> 
      <li class="nav-item">
        <sidenav-item
          url="/recaps"
          :class="getRoute() === 'recaps' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '-' : 'Recaps'"
        >
          <template v-slot:icon>
            <i class="ni ni-chart-bar-32 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> 
      

      <li class="nav-item">
        <sidenav-item
          url="/achievements"
          :class="getRoute() === 'achievements' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '-' : 'Achievements'"
        >
          <template v-slot:icon>
            <i class="fa fa-trophy text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> 
      

      <li class="nav-item">
        <div class="nav-link cursor-pointer" @click.prevent="useDropDown1()">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fab fa-vuejs text-info text-sm opacity-10"></i>
          </div>
          Users Management
          <i v-if="!dropDownStatus1" class="ms-3 fas fa-angle-right"></i>
          <i v-else class="ms-3 fas fa-angle-down"></i>
        </div>
        <ul v-if="dropDownStatus1">
          <sidenav-item
            url="/internal-users"
            :class="getRoute() === 'internal-users' ? 'active' : ''"
            navText="Internal Users"
          >
            <template v-slot:icon>
              <i class="fas fa-user-circle text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          <sidenav-item
            url="/roles"
            :class="getRoute() === 'roles' ? 'active' : ''"
            navText="User Roles"
          >
            <template v-slot:icon>
              <i class="fas fa-user-edit text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          <sidenav-item
            url="/external-users"
            :class="getRoute() === 'external-users' ? 'active' : ''"
            navText="External Users"
          >
            <template v-slot:icon>
              <i class="fas fa-user-edit text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

      <li class="nav-item">
        <sidenav-item
          url="/broadcast-signal"
          :class="getRoute() === 'broadcast-signal' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? '-' : 'Broadcast Signal'"
        >
          <template v-slot:icon>
            <i class="fa fa-signal text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> 
      
      <li class="nav-item">
        <div class="nav-link cursor-pointer" @click.prevent="useDropDown4()">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fab fa-vuejs text-info text-sm opacity-10"></i>
          </div>
          Setting
          <i v-if="!dropDownStatus4" class="ms-3 fas fa-angle-right"></i>
          <i v-else class="ms-3 fas fa-angle-down"></i>
        </div>
        <ul v-if="dropDownStatus4">
          <sidenav-item
            url="/content-management/banners"
            :class="getRoute() === 'banners' ? 'active' : ''"
            navText="Banner"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>    
          <sidenav-item
            url="/content-management/services-fee"
            :class="getRoute() === 'services-fee' ? 'active' : ''"
            navText="Service Fee"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>    
          <sidenav-item
            url="/content-management/rate"
            :class="getRoute() === 'rate' ? 'active' : ''"
            navText="Rate"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>     
          <sidenav-item
            url="/content-management/profit-targets"
            :class="getRoute() === '/profit-targets' ? 'active' : ''"
            navText="Profit Targets"
          >
            <template v-slot:icon>
              <i class="fas fa-table text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>  
        </ul>
      </li>
    </ul>
  </div>
  
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "CMS SMARTINTRADE",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus1: false,
      dropDownStatus2: true,
      dropDownStatus3: false,
      dropDownStatus4: true,

    };
  },
  components: {
    SidenavItem,
    // SidenavCard,
  },
  mounted() {},
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr.length >= 3 ? routeArr[2] : routeArr[1];
    },
    useDropDown1() {
      this.dropDownStatus1 = !this.dropDownStatus1;
    },
    useDropDown2() {
      this.dropDownStatus2 = !this.dropDownStatus2;
    },
    useDropDown3() {
      this.dropDownStatus3 = !this.dropDownStatus3;
    },
    useDropDown4() {
      this.dropDownStatus4 = !this.dropDownStatus4;
    },
  },
};
</script>
